
import { MainTitle } from '@/components/molecules'

export default {
  name: 'TitleDescription',
  components: {
    MainTitle,
  },
  props: {
    sectionData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    sectionTItle(): string {
      return this.sectionData?.title
    },
    sectionDescription(): string {
      return this.sectionData?.description
    },
  },
}
